<script setup>
import BrandLockup from '@/Components/UI/BrandLockup.vue'
</script>

<template>
  <footer class="brand-footer">
    <div class="brand-footer__inner">
      <slot name="brand"><BrandLockup class="brand-footer__lockup" /></slot>
      <div class="brand-footer__content"><slot /></div>
    </div>
  </footer>
</template>

<style scoped>
.brand-footer { border-top: 1px solid var(--line); padding: 1.5rem clamp(1.25rem, 4vw, 3rem); padding-bottom: max(env(safe-area-inset-bottom), 1.5rem); }
.brand-footer__inner { max-width: 96rem; margin: 0 auto; display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 0.75rem 1rem; color: var(--muted); font-size: 0.8125rem; }
.brand-footer__content { display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem; }
@media (max-width: 540px) { .brand-footer__inner { justify-content: center; text-align: center; } }
</style>
